import { FormInput, FormTextarea, RHF } from "@/shared/forms";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Switch } from "@/components/ui/switch";
import { LayersIcon } from "lucide-react";
import type { UseFormReturn } from "react-hook-form";

export type IngredientCategoryFormValues = {
  name: string;
  code: string;
  sortOrder: number;
  description: string;
  isActive: boolean;
};

type IngredientCategoryFormCardProps = {
  form: UseFormReturn<IngredientCategoryFormValues>;
};

export function IngredientCategoryFormCard({
  form,
}: IngredientCategoryFormCardProps) {
  return (
    <Card className="rounded-xl border bg-card">
      <CardHeader className="pb-4">
        <CardTitle className="flex items-center gap-2 font-heading text-lg">
          <LayersIcon className="size-5 text-muted-foreground" />
          ຂໍ້ມູນຫມວດ
        </CardTitle>
        <p className="text-muted-foreground text-sm">
          ຊື່ຫມວດ (ບັງຄັບ) · ລະຫັດສັ້ນ (ທາງເລືອກ) · ລຳດັບການສະແດງ
        </p>
      </CardHeader>
      <CardContent className="space-y-6">
        <FormInput
          name="name"
          label="ຊື່ຫມວດ"
          placeholder="ຕົວຢ່າງ: ນົມ ແລະ ຄຣີມ"
          requiredMark
        />
        <FormInput
          name="code"
          label="ລະຫັດ (ທາງເລືອກ)"
          placeholder="DAIRY"
        />
        <FormInput
          name="sortOrder"
          label="ລຳດັບການສະແດງ"
          type="number"
          min={0}
          step={1}
        />
        <FormTextarea
          name="description"
          label="ລາຍລະອຽດ (ທາງເລືອກ)"
          placeholder="ໝາຍເຫດສຳລັບ HQ"
          rows={3}
        />
        <div className="flex items-center justify-between rounded-[12px] border bg-muted/30 p-4">
          <div>
            <p className="font-medium text-sm">ເປີດໃຊ້</p>
            <p className="text-muted-foreground text-xs">
              ຫມວດປິດຈະບໍ່ໃຊ້ມອບຫມາຍໃໝ່
            </p>
          </div>
          <RHF.Controller
            name="isActive"
            control={form.control}
            render={({ field }) => (
              <Switch checked={field.value} onCheckedChange={field.onChange} />
            )}
          />
        </div>
      </CardContent>
    </Card>
  );
}
